module.exports = __webpack_public_path__ + "static/img/haos-game-lucre-games-banner.2f660dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/haos/haos-game-lucre-games-banner.jpg
// module id = guZ8
// module chunks = 0